import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton = ({ children, style, className }) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <button onClick={handleLogout} style={style} className={className}>
      {children || 'Log Out'}
    </button>
  );
};

export default LogoutButton;
